import { Container } from '@mui/material';
import { NextPage } from 'next';
import Head from 'next/head';
import useTranslation from 'next-translate/useTranslation';
import LegalContent from './LegalContent';
import HeaderBar from '@components/HeaderBar';
import { MARGIN_BEFORE_FOOTER } from '@styles/consts';
import { Section } from '@utils/types/legalContent';

const Cgu: NextPage = () => {
    const { t } = useTranslation('cgu');

    const sections = t('sections', undefined, { returnObjects: true }) as Array<Section>;

    return (
        <>
            <HeaderBar title={t('title')} />
            <Head>
                <title>{t('pageTitle')}</title>
            </Head>
            <Container maxWidth="md" sx={{ mb: MARGIN_BEFORE_FOOTER }}>
                <LegalContent sections={sections} />
            </Container>
        </>
    );
};

export default Cgu;
